import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import {
    subtitle,
    title as titleClass,
    bigTitle as bigTitleClass,
    playText,
    playIcon,
    videoList,
} from './video-opinions.module.scss';

import YoutubeRedIcon from '../../assets/images/svg/youtube-red.svg';
import SubTitle from '../atoms/subtitle';
import SingleVideoOpinion from '../molecules/single-video-opinion';

const VideoOpinions = ({
    title = 'Sprawdź, co mówią o nas nasi podopieczni',
    className,
    bigTitle = false,
}) => {
    const { allVideoOpinion } = useStaticQuery(query);

    const videoOpinions = allVideoOpinion ? allVideoOpinion.edges.map((edge) => edge.node) : [];

    return videoOpinions && videoOpinions.length > 0 ? (
        <div className={className}>
            <SubTitle className={`${titleClass} ${bigTitle ? bigTitleClass : ''}`}>
                {title}
            </SubTitle>
            <SubTitle className={subtitle}>
                Film uruchomi sie po kliknięciu w przycisk
                <span className={playText}>
                    &nbsp;Play <YoutubeRedIcon className={playIcon} />
                </span>
            </SubTitle>
            <section className={videoList}>
                {videoOpinions.map((video) => (
                    <SingleVideoOpinion key={`video-opinion-${video.opinionId}`} video={video} />
                ))}
            </section>
        </div>
    ) : null;
};

const query = graphql`
    query {
        allVideoOpinion {
            edges {
                node {
                    opinionId
                    videoUrl
                    content
                    videoProvider
                    author {
                        name
                        imageUrl
                    }
                }
            }
        }
    }
`;

export default VideoOpinions;
